function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 6.66686H0V0.526351C0 0.235689 0.200738 0 0.448296 0H25.5517C25.7993 0 26 0.235689 26 0.526351L26 6.66686Z",
  fill: "#3D3D4D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5517 20.0001H0.448296C0.200738 20.0001 0 19.7644 0 19.4737V13.3333H26V19.4737C26 19.7644 25.7992 20.0001 25.5517 20.0001Z",
  fill: "#FFE15A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26 6.6665H0V13.3329H26V6.6665Z",
  fill: "#FF4B55"
});

var SvgGerman = function SvgGerman(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGerman, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/german.cfb2c414.svg";
export { ForwardRef as ReactComponent };